import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import VueI18n from 'vue-i18n'
import i18n from './i18n'
import YmapPlugin from 'vue-yandex-maps'
import FishUI from 'fish-ui'
import vueCustomElement from 'vue-custom-element'
import './assets/css/main.scss'
import 'document-register-element/build/document-register-element'

const options = { // you may define your apiKey, lang and version or skip this.
    apiKey: 'xxx',
    lang: 'ru_RU',
    version: '2.1'
}

Vue.use(FishUI);
Vue.use(YmapPlugin);
Vue.use(vueCustomElement);
Vue.use(VueI18n)

Vue.config.productionTip = false

App.store = store
App.router = router

Vue.customElement('geostatus-widget', App, {
    beforeCreateVueInstance(RootComponentDefinition) {
        RootComponentDefinition.i18n = i18n
        return RootComponentDefinition
    }
})



